import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router';
import styles from './style.css';

const SidebarAccountInfoDropdownItem = props => {
  const { user, onTriggerClick, onLogoutClick } = props;

  return (
    <li className="dropdown account-info">
      <a
        href="javascript:void(0)"
        className="dropdown-toggle"
        data-toggle="dropdown"
        onClick={onTriggerClick}
      >
        <span className={`${styles['business-name']}`}>
          {user.first_name} {user.last_name}
        </span>
        <span className="glyphicon glyphicon-chevron-right account-info" />
        <br />
      </a>
      <ul className="dropdown-menu">
        <li>
          <div className="content-account-info">
            <div className="avatar col-md-4">
              {user.gravatar ? (
                <img
                  src={user.gravatar}
                  alt="account profile default"
                  width="100%"
                />
              ) : (
                <img
                  src={require('assets/images/account-profile-default.jpg')}
                  alt="account profile default"
                  width="100%"
                />
              )}
            </div>
            <div className="mk-business-info col-md-8">
              <div className="business-name gt">
                <Link to="/settings/public_profile">{user.business.name}</Link>
              </div>
              <div className="business-email">{user.email}</div>
            </div>
            <hr />
            <div className="logout col-md-12">
              <div className="logout-link">
                <Link to="#" onClick={onLogoutClick}>
                  <i className="fa fa-sign-out" />
                  &nbsp;&nbsp;Sign Out
                </Link>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </li>
  );
};

SidebarAccountInfoDropdownItem.propTypes = {
  onTriggerClick: PropTypes.func,
  onLogoutClick: PropTypes.func,
  user: PropTypes.object.isRequired,
};

SidebarAccountInfoDropdownItem.defaultProps = {
  onTriggerClick: () => {},
  onLogoutClick: () => {},
};

export default SidebarAccountInfoDropdownItem;
